var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconVisit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    rx: 6,
    fill: "#F2C94C",
    fillOpacity: 0.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 5.25C13.0335 5.25 12.25 6.0335 12.25 7H10.5C7.60051 7 5.25 9.3505 5.25 12.25V29.75C5.25 32.6495 7.60051 35 10.5 35H31.5C34.3995 35 36.75 32.6495 36.75 29.75V12.25C36.75 9.3505 34.3995 7 31.5 7L29.75 7C29.75 6.0335 28.9665 5.25 28 5.25C27.0335 5.25 26.25 6.0335 26.25 7L15.75 7C15.75 6.0335 14.9665 5.25 14 5.25ZM8.75 15.75H33.25V12.25C33.25 11.2835 32.4665 10.5 31.5 10.5H10.5C9.5335 10.5 8.75 11.2835 8.75 12.25V15.75ZM27.7437 19.8687C28.0854 19.527 28.0854 18.973 27.7437 18.6313C27.402 18.2896 26.848 18.2896 26.5063 18.6313L20.0962 25.0413L17.2136 22.4207C16.856 22.0957 16.3026 22.122 15.9776 22.4796C15.6525 22.8372 15.6788 23.3906 16.0364 23.7156L20.1538 27.4587L27.7437 19.8687Z",
    fill: "#F0C43C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVisit);
export default __webpack_public_path__ + "static/media/icon-visit.de224015.svg";
export { ForwardRef as ReactComponent };